/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  const SECTION_ID = 'api-product-upsell';

  async function swapQuickAdd(dialog, handle) {
    const target = dialog.querySelector('[data-product-upsell-ajax]');
    if (!target) return;

    const url = `/products/${handle}?section_id=${SECTION_ID}`;
    const res = await fetch(url, { credentials: 'same-origin' });

    // 🔥 CLAVE: esto es HTML, NO JSON
    const html = await res.text();

    const doc = new DOMParser().parseFromString(html, 'text/html');
    const next = doc.querySelector('[data-api-content]');
    if (!next) return;

    target.innerHTML = '';
    target.appendChild(next);
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qa-handle]');
    if (!btn) return;

    const handle = btn.dataset.qaHandle;
    const dialog = btn.closest('dialog[data-quick-add-modal]');
    if (!dialog) return;

    e.preventDefault();
    e.stopPropagation(); // 👈 importante 

    dialog.classList.add('is-loading');

    swapQuickAdd(dialog, handle)
      .catch(console.error)
      .finally(() => dialog.classList.remove('is-loading'));
  });

  
  (function () {
  const SECTION_ID = 'api-product-grid-item';

  async function fetchCard(handle) {
    const url = `/products/${handle}?section_id=${SECTION_ID}`;
    const res = await fetch(url, { credentials: 'same-origin' });
    const html = await res.text();

    const doc = new DOMParser().parseFromString(html, 'text/html');
    const api = doc.querySelector('[data-api-content]');
    if (!api) return null;

    return (
      api.querySelector('.grid-item.product-item') ||
      api.querySelector('.grid-item') ||
      api.querySelector('[data-grid-item]')
    );
  }

  async function onSwatchActivate(e) {
    const swatch = e.target.closest('[data-sibling-handle]');
    if (!swatch) return;

    const card =
      swatch.closest('.grid-item.product-item') ||
      swatch.closest('.grid-item') ||
      swatch.closest('[data-grid-item]');

    if (!card) return;

    // 🧨 mata cualquier navegación del theme
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

    const handle = swatch.dataset.siblingHandle;
    if (!handle) return;

    card.classList.add('is-loading');

    try {
      const next = await fetchCard(handle);
      if (next) card.replaceWith(next);
    } catch (err) {
      console.error('[swatch swap] error', err);
      card.classList.remove('is-loading');
    }
  }

  // Captura antes que el theme
  document.addEventListener('pointerdown', onSwatchActivate, true);
  document.addEventListener('click', onSwatchActivate, true);
})();

  // Fix: shipping calculator divide el precio /100 en CLP (moneda sin decimales)
  (function () {
    function patchShippingCalculator() {
      const ctor = customElements.get('shipping-calculator');
      if (!ctor) return false;

      ctor.prototype.formatRate = function (cents) {
        const value = String(cents).trim();
        if (value === '0.00' || value === '0' || parseInt(value, 10) === 0) {
          return window.theme.strings.free;
        }
        // el rate ya viene en pesos enteros; no volver a dividir
        return '$' + parseInt(value, 10).toLocaleString('es-CL'); // 9900 -> "$9.900"
      };
      return true;
    }

    if (!patchShippingCalculator()) {
      customElements.whenDefined('shipping-calculator').then(patchShippingCalculator);
    }
  })();


    // Agrega "(opcional)" al label de código postal en el shipping calculator
  (function () {
    function addOptionalLabel() {
      const label = document.querySelector('#shipping-calculator label[for="address_zip"]');
      if (label && !label.textContent.includes('(')) {
        label.textContent = label.textContent.trim() + ' (opcional)';
      }
    }

    // corre al cargar
    if (document.readyState !== 'loading') addOptionalLabel();
    else document.addEventListener('DOMContentLoaded', addOptionalLabel);

    // y observa el DOM por si el carrito/drawer se renderiza después
    const observer = new MutationObserver(addOptionalLabel);
    observer.observe(document.body, { childList: true, subtree: true });
  })();




    // Cambia el título del acordeón de envío a "Calcular fecha de entrega estimada"
  (function () {
    const NEW_TEXT = 'Calcular fecha de entrega estimada';

    function updateTitle() {
      document.querySelectorAll('.cart__widget__title').forEach((title) => {
        // solo el que contiene el shipping calculator
        const widget = title.closest('.cart__widget');
        if (!widget || !widget.querySelector('#shipping-calculator')) return;

        // reemplaza solo el nodo de texto, sin borrar los iconos +/-
        title.childNodes.forEach((node) => {
          if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
            node.textContent = NEW_TEXT;
          }
        });
      });
    }

    if (document.readyState !== 'loading') updateTitle();
    else document.addEventListener('DOMContentLoaded', updateTitle);

    const observer = new MutationObserver(updateTitle);
    observer.observe(document.body, { childList: true, subtree: true });
  })();


    // Cambia el texto del botón del shipping calculator
  (function () {
    const NEW_TEXT = 'Calcular costos y tiempo';

    // sobrescribe el string que el tema usa para restaurar el botón tras calcular
    if (window.theme && window.theme.strings) {
      window.theme.strings.shippingCalcSubmitButton = NEW_TEXT;
    }

    function updateButton() {
      document.querySelectorAll('#shipping-calculator .get-rates').forEach((btn) => {
        // no lo toques mientras dice "Calculando"
        if (btn.textContent.trim() && btn.textContent.trim() !== NEW_TEXT && !btn.disabled) {
          btn.textContent = NEW_TEXT;
        }
      });
    }

    if (document.readyState !== 'loading') updateButton();
    else document.addEventListener('DOMContentLoaded', updateButton);

    const observer = new MutationObserver(updateButton);
    observer.observe(document.body, { childList: true, subtree: true });
  })();


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();





